import getCalendarEventByItemIdFromCache from '../store/apis/getCalendarEventByItemIdFromCache';
import { CalendarEvent } from 'mini-calendar-event-types';

/**
 * Returns the calendar event corresponding to the given event id
 * @param eventId string
 */
export default function getCalendarEventForEventId(eventId: string): CalendarEvent {
    return getCalendarEventByItemIdFromCache(eventId);
}
